module.exports = "https://static.wmbcdn.com/uniweb/images/bac949fe8dec30747b17b4b0c54630ed.png";